import { logger } from 'logger';
import { useEffect } from 'react';
import { Device, DeviceSubtype, getDevice, getDeviceSubtype } from 'utils/getDevice';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const LOG = logger.getLogger('useConnectedTags');

const device = getDevice();
const deviceSubtype = getDeviceSubtype();

export function useConnectedTags(): void {
  useEffect(() => {
    const androidContent = 'width=device-width, initial-scale=.5, user-scalable=no';
    const vegaContent = 'width=device-width,initial-scale=1';
    const xboxContent = 'width=device-width, initial-scale=.5, user-scalable=no';
    const lgtvContent = 'width=device-width, initial-scale=.5, user-scalable=no';
    const metaTag = document.createElement('meta');
    metaTag.name = 'viewport';
    if (device === Device.xbox) {
      LOG.debug('using xbox metaTag');
      metaTag.content = xboxContent;
    } else if (device === Device.lgtv) {
      LOG.debug('using lgtv metaTag');
      metaTag.content = lgtvContent;
    } else if (device === Device.androidtv || device === Device.firetv) {
      if (deviceSubtype === DeviceSubtype.vegaos) {
        LOG.debug('using vega metaTag');
        metaTag.content = vegaContent;
      } else {
        LOG.debug('using android metaTag');
        metaTag.content = androidContent;
      }
    } else {
      assertNever(device);
    }

    document.getElementsByTagName('head')[0].appendChild(metaTag);
  }, []);
}

function assertNever(device: never): never {
  throw new Error(`Unhandled type ${device}`);
}
